<app-module-error class="flex-fill" *ngIf="noData" [noData]="true"></app-module-error>
<div class="w-100 h-100 position-relative" *ngIf="!noData && chartConfig">
    <canvas baseChart 
        [type]="chartConfig.type"
        [legend]="chartConfig.options.plugins.legend.display"
        [datasets]="chartConfig.data.datasets"
        [labels]="chartConfig.data.labels"
        [options]="chartConfig.options"
        [plugins]="chartConfig.plugins">
    </canvas>
</div>
